import { atom } from "jotai";

import { BookingAnalyticsData } from "@/screens/BookingDetail/NewPatronBookingFlow/types";

export const bookingSummaryAnalyticsDataAtom = atom<BookingAnalyticsData>(null);
